import { Box, Button, Typography } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'

const BlogHoverBox = ({content,link,title,date}) => {
  return (
    <Box
    className="blog_hover"
    sx={{
      background: "rgb(255 255 255 / 75%)",
      backdropFilter: "blur(8px)",
      borderRadius: "5px",
      p: "1rem 0.5rem 0",
      position: "absolute",
      bottom: "0",
      // display:"none"
    }}
  >
    <Typography
      sx={{
        fontSize: "18px",
        color: "#1475F7",
        //   py: "0.5rem",
        lineHeight:"1.5rem",
        textAlign: "center",
      }}
    >
     {title}
    </Typography>
    <Typography
      sx={{
        fontSize: "16px",
        color: "#212121",
        py: "0.5rem",
        width: { sm: "90%", xs: "100%" },
        m: "0 auto",
        textAlign: "center",
      }}
    >
      {content?content:"Quality sleep is essential for overall health and well being but..."}
    </Typography>
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Typography
        sx={{
          fontSize: "16px",
          color: "#1475F7",
        }}
      >
        {date}
      </Typography>
      <Button
      component={Link}
      to={link}
        sx={{
          background: "transparent",
          color: "#1475F7",
          fontFamily: "poppins",
          padding: "6px 10px !important",
          lineHeight: "initial !important",
          fontSize: "16px",
          // width: { sm: "120px", xs: "50%" },
          "&:hover": {
            background: "transparent",
          },
          //   display: "block",
          //   m: "0 auto",
          border: "1px solid #1475F7",
          borderRadius: "5px",
          textTransform: "capitalize",
        }}
      >
        Continue reading...
      </Button>
    </Box>
  </Box>
  )
}

export default BlogHoverBox